import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  /**
   *
   * Takes a UTC dateTime, converts it to MM/DD/YYYY while maintaining the date in UTC
   * @param date A UTC date
   * @param seperator Character used to seperate month, day, year
   * @returns string formatted MM DD YYYY with given seperator
   */
  static formatDateMaintainUTC(
    date: string | number | Date,
    seperator: string = '/',
  ) {
    const d = new Date(date);
    let month = (d.getUTCMonth() + 1).toString(),
      day = d.getUTCDate().toString(),
      year = d.getUTCFullYear().toString();

    // Add 0 to month and day if below 10
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    return [month, day, year].join(seperator);
  }
  /**
   *
   * Takes a UTC dateTime, converts it to MMDDYY while maintaining the date in UTC
   * @param date A UTC date
   * @param seperator Character used to seperate month, day, year
   * @returns string formatted MM DD YYYY with given seperator
   */
  static formatShortDateMaintainUTC(
    date: string | number | Date,
    seperator: string = '/',
  ) {
    const d = new Date(date);
    let month = (d.getUTCMonth() + 1).toString(),
      day = d.getUTCDate().toString(),
      year = d.getUTCFullYear().toString().substring(2);

    // Add 0 to month and day if below 10
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    return [month, day, year].join(seperator);
  }
}
